import React from "react"

type StepsProps = {
  children:any
}

export const Steps = (props: StepsProps) => {
  return (
    <div className="flex flex-col gap-3">
      {React.Children.map(props.children, (child, index) => {
        return React.cloneElement(child, { index, last: index === props.children.length - 1})
      })}
    </div>
  )
}
